<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">#</th>
        <th scope="col" class="border-0">Nome</th>
        <th scope="col" class="border-0">E-mail</th>
        <th scope="col" class="border-0">{{ label }}</th>
        <th scope="col" class="border-0">Enviado</th>
        <th scope="col" class="border-0">Respondido</th>
        <th scope="col" class="border-0">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in users" :key="index">
        <td>{{ row.id }}</td>
        <td class="td-4 link">
          <d-link :to="{ name: 'admin-rating-user', params: { userId: row.id }}">{{ row.user.name }}</d-link>
        </td>
        <td class="td-3">{{ row.user.email }}</td>
        <td class="td-4 link">
          <d-link :to="{ name: 'admin-ticket-edit', params: { ticketId: row.ticket.id }}" v-if="type === 'ticket' && row.ticket" >{{ row.ticket.title }}</d-link>
          <d-link :to="{ name: 'admin-project-edit', params: { projectId: row.project.id }}" v-if="type === 'project' && row.project" >{{ row.project.label }}</d-link>
        </td>
        <td class="td-2">{{ row.f_created_at }}</td>
        <td class="td-2">{{ row.f_answered_at }}</td>
        <td class="td-2">
          <d-button @click="resend(row.id)" v-if="row.f_answered_at == null">Reenviar</d-button>
        </td>
      </tr>
      <tr v-if="users.length === 0">
        <td colspan="7" class="no-content">Ainda não foi enviada nenhuma avaliação.</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapActions } from 'vuex';
import RatingService from '_services/rest/modules/rating';

export default {
  name: 'rating-user-table',
  computed: {
    label() {
      if (this.type === 'ticket') {
        return 'Chamado';
      }
      return 'Obra';
    },
  },
  props: {
    users: {
      type: Array,
    },
    type: {
      type: String,
    },
  },
  data() {
    return {
      selectUser: null,
    };
  },
  methods: {
    ...mapActions([
      'activeAlert',
    ]),
    resend(id) {
      RatingService.resend(id)
        .then(() => {
          this.activeAlert({ message: 'Formulário enviado com sucesso', theme: 'success' });
        });
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  color: $primary;
  a {
    cursor: pointer;
  }
}

.td {
  &-2 {
    min-width: 140px;
  }
  &-3 {
    min-width: 140px;
  }
  &-4 {
    min-width: 200px;
  }
}
</style>
